<template>
  <div class="cart orderList reservationList" :class="{isPublic: isPublic}">
    <h1 class="boxTitle mb15 notranslate">
      <router-link v-if="isPackage"
        :to="{ name: 'mypackage' }"
        class="btnMypackage">
        {{ locale.mypackage_history }}
      </router-link>
      {{locale.reservation_list}}
    </h1>
    <div v-if="list.length" class="list">
      <ReservationItem
        v-for="item in list"
        :key="item.order_id"
        :order="item"
        :locale="locale"
        :lang="lang"
        :ln="ln"
        :isPublic="isPublic"
        :isPackage="isPackage"
        :auth="auth"
        @cancel="cancel" />
    </div>
    <div v-else class="noData notranslate">{{locale.reservation_nodata}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReservationItem from '@/components/Mypage/ReservationItem'

export default {
  name: 'ReservationList',
  props: [
    'lang',
    'ln',
    'locale',
    'isPublic'
  ],
  components: {
    ReservationItem
  },
  computed: {
    ...mapGetters({
      metaInfo: 'authentication/getMetaInfo',
      auth: 'authentication/getAuthInfo',
      guestUserInfo: 'guest/getGuestUserInfo'
    }),
    isPackage () {
      return this.$route.params.package
    }
  },
  async mounted () {
    await this.getKey()
    this.$nextTick(() => {
      this.getOrderHistory()
    }, 300)
  },
  data () {
    return {
      list: [],
      space: this.$store.state.authentication.space,
      key: this.$store.state.authentication.k
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'orderList'
      })
    },
    async getOrderHistory () {
      this.$store.commit('loading', true)
      const next = this.next
      const mypageType = this.$route.name.replace('my', '').toLowerCase()
      const guestPackages = (this.guestUserInfo && this.guestUserInfo.packages) || []
      const data = {
        mypageType: mypageType,
        paging: {
          limit: 30,
          ...next && {
            next: next
          }
        },
        ...this.isPackage && {
          filter: {
            isPackage: true,
            ...guestPackages.length > 0 && {
              guestPackages: guestPackages
            }
          }
        }
      }
      const history = await this.$store.dispatch('guest/getMypageHistory', data)
      if (history && history.items) {
        this.list = this.list.map(x => {
          return {
            ...x,
            firstItem: false
          }
        }).concat(history.items.map((x, i) => {
          return {
            ...x,
            firstItem: i === 0 // 새로 불러온 첫 아이템으로 스크롤 하기 위한 flag
          }
        }))
      }
      this.$store.commit('loading', false)
      this.next = (history && history.next) || null
      this.scrollList()
      return history
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    async init () {
      this.track()
    },
    scrollList () {
      this.$nextTick(() => {
        const list = this.$refs.mypageList
        const firstItem = document.querySelector('.firstItem')
        if (firstItem && this.moreCount > 0) {
          const top = firstItem.offsetTop
          const height = firstItem.offsetHeight
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          })
        }
        this.moreCount += 1
      })
    },
    cancel (id) {
      this.$store.dispatch('reservation/cancelReservation', id).then((res) => {
        if (res) {
          alert(this.locale.alert_complete_reservation_cancel)
          this.init()
        } else {
          alert(this.alert_system_error)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding: 90px 0;
  text-align: center;
}
</style>
